export default __webpack_public_path__ + "media/images/Document-e4d720595d5f2da08540201bf28f7195.png";